import { render } from "./TopListCard.vue?vue&type=template&id=a90083e8&scoped=true"
import script from "./TopListCard.vue?vue&type=script&lang=js"
export * from "./TopListCard.vue?vue&type=script&lang=js"

import "./TopListCard.vue?vue&type=style&index=0&id=a90083e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90083e8"]])

export default __exports__